import i18n from "i18next";
import {initReactI18next} from "react-i18next";

import LanguageDetector from 'i18next-browser-languagedetector';
import {LANGUAGES_WHITE_LIST, FALLBACK_LANG} from "./constants";
// don't want to use this?
// have a look at the Quick start guide
// for passing in lng and translations on init

const languagesWhitelist = LANGUAGES_WHITE_LIST;

const languageDetectorOptions = {
    // order and from where user language should be detected
    order: ['path', 'localStorage', 'navigator'],

    // keys or params to lookup language from
    lookupFromPathIndex: 0,
};

const HttpBackendOptions = {
    loadPath: process.env.REACT_APP_LOCALES_ROOT_URL + '{{lng}}/{{ns}}.json',

    // path to post missing resources, or a function
    // function(lng, namespace) { return customPath; }
    // the returned path will interpolate lng, ns if provided like giving a static path
    addPath: '/locales/add/{{lng}}/{{ns}}',

    // your backend server supports multiloading
    // /locales/resources.json?lng=de+en&ns=ns1+ns2
    // Adapter is needed to enable MultiLoading https://github.com/i18next/i18next-multiload-backend-adapter
    // Returned JSON structure in this case is
    // {
    //  lang : {
    //   namespaceA: {},
    //   namespaceB: {},
    //   ...etc
    //  }
    // }
    allowMultiLoading: false, // set loadPath: '/locales/resources.json?lng={{lng}}&ns={{ns}}' to adapt to multiLoading

    // parse data after it has been fetched
    // in example use https://www.npmjs.com/package/json5
    // here it removes the letter a from the json (bad idea)
    // parse: function(data) { return data.replace(/a/g, ''); },

    //parse data before it has been sent by addPath
    // parsePayload: function(namespace, key, fallbackValue) { return { key } },

    // allow cross domain requests
    crossDomain: true,

    // allow credentials on cross domain requests
    withCredentials: false,

    // overrideMimeType sets request.overrideMimeType("application/json")
    overrideMimeType: false,

    requestOptions: { // used for fetch, can also be a function (payload) => ({ method: 'GET' })
        mode: 'cors',
        credentials: 'same-origin',
        cache: 'default'
    }

};

const compileStrings = ctx => {
  const compiled = { resources: {}, ns: [] };
  // This regex does not work for en-US, en-UK, etc.
  const fileRegex = /(?<context>\w*)\/(?<locale>\w+)\/(?<fileName>\w+)\.json$/;

  ctx.keys().forEach(file => {
    const { fileName, locale } = file.match(fileRegex).groups;

    compiled.resources[locale] = !!compiled.resources[locale] ? compiled.resources[locale] : {};
    compiled.resources[locale][fileName] = ctx(file);
  });

  return compiled;
};
const strings = compileStrings(require.context('../locales', true, /\w+\.json$/));


i18n
    // detect user language
    // learn more: https://github.com/i18next/i18next-browser-languageDetector
    .use(LanguageDetector)
    // pass the i18n instance to react-i18next.
    .use(initReactI18next) // passes i18n down to react-i18next
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
        whitelist: languagesWhitelist,
        keySeparator: '.',
        nonExplicitWhitelist: true,
        returnNull: false,
        load: 'languageOnly',
        fallbackLng: FALLBACK_LANG,
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },

        detection: languageDetectorOptions,
        resources: strings.resources,
    });

export default i18n;
